/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.64"
        height="95.58"
        viewBox="0 0 79.64 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="none"
          stroke="#0e497b"
          d="M39.82 94.33C4.94 81.8 1.25 55.06 1.25 30.99V15.78c15.6-.47 28.1-5.14 38.57-14.53 10.47 9.39 23 14.06 38.57 14.53v15.21c0 24.07-3.69 50.81-38.57 63.34Z"
          className="icon-stroke icon-base"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"/>
        <path
          fill="#ffb81c"
          d="M38.37 26.8v3.7l-.56.1-.57.12a8.76 8.76 0 0 0-6.6 5.35 10.87 10.87 0 0 0-.76 5 8.58 8.58 0 0 0 4.62 7.22 39.93 39.93 0 0 0 3.83 1.72c1.61.67 3.24 1.29 4.84 2a2.91 2.91 0 0 1 1.82 3.19 3.18 3.18 0 0 1-2.56 3.19 9.19 9.19 0 0 1-2 .22 5 5 0 0 1-5.15-3.76c-.14-.45-.25-.91-.39-1.4L28.71 55a12.75 12.75 0 0 0 3 6 10.29 10.29 0 0 0 6.71 3.09v4.73h4v-4.63c.8-.16 1.57-.29 2.32-.48a9.14 9.14 0 0 0 6.35-5.21 10.68 10.68 0 0 0 .74-6.38 8.4 8.4 0 0 0-4.28-6.07 46.82 46.82 0 0 0-5.86-2.55c-1.19-.48-2.36-1-3.52-1.6a2.52 2.52 0 0 1-1.31-1.59 3.57 3.57 0 0 1 2.5-4.5 4.15 4.15 0 0 1 4.14 1.05 7.89 7.89 0 0 1 1.66 2.52c.14.29.26.6.4.92l5.47-2.26a11 11 0 0 0-2-4.13 9.68 9.68 0 0 0-6.71-3.41v-3.7Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithDollarSignIcon';

export default Icon;
